/* eslint-disable no-param-reassign */
import { sity } from 'shared/modules/subjectiveText/allText';
import seoTemplatest from './seoTemplates';
import { paramsToSeoData } from './seoDataFinder';
/* import { AVTO } from './seoTemplates/search/avto';
import { AVTOSALONY } from './avtosalony'; */

const avaliableTransports = {
  легковые: 'AVTO',
  'водный транспорт': 'VODNYI_TRANSPORT',
  автобусы: 'AVTOBUS',
  грузовые: 'GRUZOVYE',
  мотоциклы: 'MOTOTSIKL',
  прицепы: 'PRITSEPY',
  спецтехника: 'SPETSTEHNIKA',

  мототранспорт: 'MOTO',
  грузовики: 'GRUZOVYE',

  // UK
  легкові: 'AVTO',
  'водний транспорт': 'VODNYI_TRANSPORT',
  автобуси: 'AVTOBUS',
  вантажні: 'GRUZOVYE',
  мотоцикли: 'MOTOTSIKL',
  причепи: 'PRITSEPY',
  спецтехніка: 'SPETSTEHNIKA',

  avto: 'AVTO',
  moto: 'MOTO',

  'vodnyi-transport': 'VODNYI_TRANSPORT',
  avtobus: 'AVTOBUS',
  gruzovye: 'GRUZOVYE',
  mototsikl: 'MOTOTSIKL',
  pritsepy: 'PRITSEPY',
  spetstehnika: 'SPETSTEHNIKA',

  kvadrotsikl: 'KVADROTSIKL',
  квадроцикл: 'KVADROTSIKL',

  moped: 'MOPED',
  мопед: 'MOPED',

  skuter: 'SKUTER',
  скутер: 'SKUTER',

  baggi: 'BAGGI',
  багги: 'BAGGI',
  баггі: 'BAGGI',

  трицикл: 'TRITSIKL',
  tritsikl: 'TRITSIKL',
};

const avaliableCategories = {
  avtosalony: 'AVTOSALONY',
  zapchasti: 'ZAPCHASTI',
  commercial: 'COMMERCIAL',
};

const avaliablePartTypes = {
  маховик: 'MAHOVIK',
  // патрубок: 'PATRUBOK',
  патрубки: 'PATRUBKI',
  датчики: 'DATCHIKI',
  'датчик abs': 'DATCHIKI__ABS',
  'клапан egr': 'KLAPANI__EGR',
};

const avaliableRubrics = {
  двигатель: 'DVIGATEL',
  Двигун: 'DVIGATEL',
  'электрика и электроника': 'ELEKTRIKA__I__ELEKTRONIKA',
};

// ZAPCHASTI_AVTO_DVIGATEL_PATRUBOK,
// ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI,
// ZAPCHASTI_AVTO_ELEKTRIKA__I__ELEKTRONIKA_DATCHIKI__ABS,
// ZAPCHASTI_AVTO_DVIGATEL_KLAPAN__EGR,

function getTransport(params) {
  // const key = params.transport ? params.transport.toLowerCase() : '';
  const key = params.transport ? params.transport.toLowerCase() : (params.transportType ? params.transportType.toLowerCase() : '');
  if (!key || !avaliableTransports[key]) return avaliableTransports.avto;
  return avaliableTransports[key];
}

function getRubric(params) {
  const key = params.rubric ? params.rubric.toLowerCase().replace('-', '__') : '';
  if (!key || !avaliableRubrics[key]) return '';
  return avaliableRubrics[key];
}

function getPartType(params) {
  const key = params.partType ? params.partType.toLowerCase().replace('-', '__') : '';
  const keyUk = params.partTypeUk ? params.partTypeUk.toLowerCase().replace('-', '__') : '';
  if (!key || !avaliablePartTypes[key.toLowerCase()]) return '';
  return avaliablePartTypes[keyUk] || avaliablePartTypes[key];
}

function makePath(params, category) {
  const transportKey = getTransport(params);
  if (!category) return transportKey;

  const partType = getPartType(params);
  const rubric = getRubric(params);
  const path = `${avaliableCategories[category]}_${transportKey}`;
  return `${path}${rubric ? `_${rubric}` : ''}${partType ? `_${partType}` : ''}`;
}

/**
 * Get SEO texts by input params.
 * @param {object} params 
 * @param {object} path 
 * @param {function} t 
 * @returns {object} {header: 'h1 text', title: 'meta tag title', description: 'meta tag '}
 */
export const getSeoDataByParams = (params, t, category) => {
  let city = '';
  if (typeof params.city === 'object' && params.city.is_city) {
    city = params.city.title || '';
  } else if (
    params.location &&
    typeof params.location === 'string' &&
    params.location !== (params.country && params.country.title)
  ) {
    city = sity[params.location] ? params.location : '';
  }

  const path = makePath(params, category);
  const seoDataLinks = seoTemplatest[path];

  if (!seoDataLinks) {
    console.warn('SEO Data Not found ', path);
    return {};
  }

  // console.log(params);
  const paramsToSeo = { ...params, city };
  return paramsToSeoData(paramsToSeo, seoDataLinks, t);
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/index.js